import { getLocation, replace } from 'connected-react-router';
import { Middleware } from 'redux';
import { createMessengerToViewport } from './create-messenger';
import isShallowEqual from '@robotsnacks/shallow-equal';
import { omit } from 'lodash';
import qs from 'qs';

const IGNORE = ['viewport'];

export const receiveViewportLocationChangeMiddleware = (): Middleware => {
  const messenger = createMessengerToViewport();

  return store => {
    messenger.on(
      'viewport-location-change',
      ({ location: viewportLocation }) => {
        const location = getLocation(store.getState());

        const url = new URL(viewportLocation, window.location.href);

        const incomingQuery = omit(
          qs.parse(url.search, { ignoreQueryPrefix: true }),
          IGNORE,
        );

        const currentQuery = omit(
          qs.parse(location.search, { ignoreQueryPrefix: true }),
          IGNORE,
        );

        if (
          location.pathname !== url.pathname ||
          !isShallowEqual(incomingQuery, currentQuery)
        ) {
          store.dispatch(
            replace({
              pathname: url.pathname,
              search: qs.stringify(incomingQuery, { addQueryPrefix: true }),
            }),
          );
        }
      },
    );

    return next => action => next(action);
  };
};
